import DefaultModal from "components/Common/Modal/DefaultModal";
import React from "react";
import { useNavigate } from "react-router-dom";
import ModalButton from "components/Common/Modal/ModalButton";

const ChannelGuideModal = ({ modalClose }: { modalClose: () => void }) => {
  const navigate = useNavigate();

  const handleGoToMypage = () => {
    navigate("/mypage/edit");
    modalClose();
  };

  return (
    <DefaultModal
      handlModalClose={modalClose}
      state="error"
      title="SNS정보가 아직 등록되지 않았어요"
      content={`데이터를 확인하려면\n내 SNS 정보를 먼저 등록해주세요.`}
      button={
        <ModalButton
          buttonType="two"
          confirmButtonText="마이페이지"
          cancelButtonText="다음에 하기"
          handleConfirm={() => {
            handleGoToMypage();
            modalClose();
          }}
          handleCancel={modalClose}
        />
      }
    />
  );
};

export default ChannelGuideModal;
